module.exports = __webpack_public_path__ + "static/media/tiny-robot.fd9d6dc8.gif";